import React from "react"
//import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PageTitle from "../components/page-title/page-title"
import TimeLine from "../components/timeline/timeline"
const pageHeading = "Experience"
//const pageSubHeading = `My work experience as a developer and designer:`

const timelineContent = {
  timelineEvents: [
    {
      time: "June 2017 – present",
      title: "Senior Front-End Developer",
      location:
        "Stanley Black & Decker  (manufacturing) , New Britain, Connecticut",
      description:
        "I lead a team of front-end developers to deliver component-based design systems using modern tooling with task runners, preprocessing and testing for data-driven and authored content on Sitecore websites. I am a hands-on developer leading by example. I also do code reviews and merges to ensure code quality and troubleshooting build issues in the continuous integration and delivery pipeline using Azure DevOps.",
    },
    {
      time: "May 2015 – May 2017",
      title: "Front-End Developer",
      location:
        "Stanley Black & Decker  (manufacturing) , New Britain, Connecticut",
      description:
        "I focused on enhancement and maintenance for Sharepoint and Sitecore e-commerce websites using an Agile software development lifecycle and Scrum methodology through collaboration with designers, marketing managers, and other developers to ensure brand consistency, accessibility and usability.",
    },
    {
      time: "July 2012 – January 2015",
      title: "Creative Director",
      location:
        "NETS, A Division of Newgen NA  (Educational Publishing) , Bloomfield, Connecticut",
      description:
        "I provided art direction and project management services, continually improving our workflows and processes. I managed domestic teams of 2–7 designers as well as several design implementation projects with larger teams at our offshore production facility in Chennai, India.",
    },
    {
      time: "April 2010 – July 2012",
      title: "Senior Designer",
      location: "NETS  (Educational Publishing) , Bloomfield, Connecticut",
      description:
        "I led the interactive whiteboard initiative’s research and development. I combined my print and web design experience, along with our strong content development expertise to create new and exciting classroom activities. This effort kept the company relevant with changing technology and opened up a new revenue stream when publishers were holding off on traditional textbook development. The growth in this area kept our doors open during tough times.",
    },
    {
      time: "April 2005 – April 2010",
      title: "Graphic Designer ",
      location: "NETS  (Educational Publishing) , Bloomfield, Connecticut",
      description:
        "I began as a textbook designer and soon after received the opportunity to apply my interactive design and coding abilities that were a hobby prior to this. I became involved in the interactive side of the business, becoming the lead on all interactive design and production work.",
    },
    {
      time: "October 2007 – April 2009",
      title: "Instructor ",
      location:
        "Saturday Tech Academy  (Magnet School)  ,  Windsor, Connecticut",
      description:
        "I taught three classes on Flash game development on Saturdays, developing the curriculum and planning lessons as well as providing hands-on training to students. Due to budget constraints, this program was discontinued after two years.",
    },
    {
      time: "October 2007 – April 2009",
      title: "Graphic Designer  ",
      location:
        "Engineering Services & Products Company  (Product Development) , South Windsor, Connecticut",
      description:
        "I was hired originally to design covers and layouts in their print catalogs, I asked to rework their existing website as it was outdated and didn’t speak to the range of products the company developed so I designed a modern, human and search engine friendly website for each of the business units as well as began weekly email marketing campaigns to help drive website traffic. I left to work in a more creative environment and challenge my professional abilities.",
    },
    {
      time: "April 2002 – July 2002",
      title: "Art Director ",
      location: "Lewtan Industries ( Advertising)  , Hartford, Connecticut",
      description:
        "I managed four designers, providing art direction and training, and quality control for the art department. I buffered the designers from the operations side of the business as well as from the client side.",
    },
    {
      time: "October 2000 – April 2002",
      title: "Graphic Designer  ",
      location: "Lewtan Industries ( Advertising)  , Hartford, Connecticut",
      description:
        "I prepared customer branding to be used in silk-screening, sublimation and hot-stamping. Sometimes it was done as paste up, eventually it was all done through scanning, digital touch up or completely recreating art, typesetting and producing color separations for our production team.",
    },
  ],
}

const ExperiencePage = () => (
  <Layout>
    <SEO title="Experience" />
    {/* <h1>Hi from the second page</h1>
    <p>Welcome to page 2</p>
    <Link to="/">Go back to the homepage</Link> */}

    {/* <p>{pageBody.pageBodySections.length} Test</p> */}
    {/* for(let i = 0; i < pageBody.length; i++){

    } */}

    <article className="experience">
      <div className="experience-head">
        <div className="container">
          <PageTitle pageHeading={pageHeading} />
        </div>
      </div>

      {/* <div className="experience-intro">
        <div className="container">
          <h2>{pageSubHeading}</h2>
        </div>
      </div> */}

      {/* <div className="experience-body">
        <div className="container"></div>
      </div> */}
    </article>
    <TimeLine timelineContent={timelineContent} />
  </Layout>
)

export default ExperiencePage
